import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Theme } from '@mui/material';
import { colorPalette } from '@qualifio/ui-commons';
import { makeStyles } from '@mui/styles';
import { superAdminIcon } from '../icons';

interface StyleProps {
  enableSpacing: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>(({ spacing }) => ({
  container: {
    display: 'inline-block',
    backgroundColor: colorPalette.blue.main,
    color: colorPalette.white.main,
    borderRadius: 50,
    padding: '7px 6px 6px 6px',
    width: 30,
    height: 30,
    fontSize: 16,
    marginLeft: ({ enableSpacing }) => (enableSpacing ? spacing(0.5) : 0),
  },
}));

export interface SuperAdminMarkerProps {
  spacing?: boolean;
}

export function SuperAdminMarker({ spacing = true }: SuperAdminMarkerProps) {
  const classes = useStyles({ enableSpacing: spacing });

  return (
    <span className={classes.container}>
      <FontAwesomeIcon icon={superAdminIcon} />
    </span>
  );
}
